import { isNil } from 'lodash';

export class MunicipalityAlarm {
  constructor(
    public municipalityKey?: string,
    public alarmsCount?: number,
  ) {}
  public hasActiveAlarm: boolean = isNil(this.alarmsCount) ? false : this.alarmsCount > 0;
}

/*
  * Important: Used by Views endpoint. Remove when all Views endpoint are deprecated or when this is not used
  ! This will be deprecated, do not use
  */
export interface BuildingAlarm {
  guid: string;
  buildingId: string;
  connectionObjectNumber: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  district: string;
  compoundedAddress: string;
  longitude?: number;
  latitude?: number;
  buildingTypesName: string;
  alarmsCount: number;
  isEnergyGuardNotificationActive: boolean;
  isEnergyGuardLicenseAvailable: boolean;
  dataSource: MeterAlarm[];
  houseNumberAdditive: string;
  municipality: string;
  municipalityKey: string;
  alarms: MeterAlarm[];
}

export interface MeterBuildingAlarm {
  alarms: MeterAlarm[];
  alarmsCount: number;
  buildingId: string;
  building: {
    buildingType: {
      name: string;
    };
    guid: string;
    isEnergyGuardNotificationActive: boolean;
  };
  buildingTypesName: string;
  compoundedAddress: string;
  connectionObjectNumber: string;
  dataSource?: MeterAlarm[];
  district: string;
  egAlarms: {
    egAlarmEvents: EgAlarmEvent[];
    isActive: boolean;
  }[];
  energyType: { name: string };
  guid: string;
  houseNumber: string;
  houseNumberAdditive: string;
  isEnergyGuardLicenseAvailable: boolean;
  isEnergyGuardNotificationActive: boolean;
  latitude: number;
  longitude: number;
  municipality: string;
  municipalityKey: string;
  street: string;
  zipCode: string;
}

export interface MeterAlarm {
  alarms: EgAlarmEvent[];
  billingCategory: string;
  buildingTypesName: string;
  connectionObjectNumber: string;
  count: number;
  deviceEUI: string;
  district: string;
  energyTypeId: string;
  energyTypesName: string;
  guid: string;
  houseNumber: string;
  isAnAlarmActive: boolean;
  isEnergyGuardLicenseAvailable: boolean;
  komKey: string;
  komKeyArray?: string[];
  marketLocationKey: string;
  meterNumber: string;
  meterTypeCode: string;
  meterTypeId: string;
  meterTypesName: string;
  municipalityKey: any;
  notes: string;
  sensorID: string;
  serialNumber: string;
  street: string;
  zipCode: string;
}

export interface Alarm {
  alarmStartDate: Date;
  guid: string;
  isResolved: boolean;
  meterId: string;
}

export class AlarmRules {
  [key: number]: string[];
}

export interface BuildingAlarmResponse {
  data: MeterBuildingAlarm[];
  maxRowCount: number;
}

export interface EgAlarm {
  alarmResolvedDate: Date;
  alarmStartDate: Date;
  connectionObjectNumber: string;
  creationDate: Date;
  egAlarmEvents: EgAlarmEvent[];
  guid: string;
  isActive: boolean;
  isResolved: boolean;
  meterId: string;
  modifyDate: Date;
  modifyUser: string;
  municipalityId: string;
  municipalityKey: string;
  pkid: number;
  ratingResult: string;
  ruleIds: any;
  serialNumber: string;
}

export interface EgAlarmEvent {
  alarmId: string;
  creationDate: Date;
  eventDate: Date;
  expectedValue: number;
  guid: string;
  modifyDate: Date;
  modifyUser: string;
  pkid: string;
  ratingResult: string;
  ruleId: string;
  ruleName: string;
  triggerValue: number;
}
